import { render, staticRenderFns } from "./DetailApprovalEditGadai.vue?vue&type=template&id=41861301&"
import script from "./DetailApprovalEditGadai.vue?vue&type=script&lang=js&"
export * from "./DetailApprovalEditGadai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports